import {
  Container,
  FadeIn,
  FadeInStagger,
  GeneralErrorBoundary,
} from "@/aptim/aptim";
import { Link } from "@remix-run/react";
import { formatDate } from "date-fns";

export function CaseStudies({ posts }) {
  return (
    <>
      <Container className="mt-16">
        <FadeInStagger className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          {posts.map((post) => (
            <FadeIn key={post.slug} className="flex">
              <article className="relative flex w-full flex-col rounded-3xl p-6 ring-1 ring-neutral-950/5 transition hover:bg-neutral-50 sm:p-8">
                <h3>
                  <Link to={`/resources/${post.slug}`}>
                    <span className="absolute inset-0 rounded-3xl" />
                    <img
                      src={post.featuredImage.node.sourceUrl}
                      alt={posts.title}
                      className="h-16 w-16"
                    />
                  </Link>
                </h3>
                <p className="mt-6 flex gap-x-2 text-sm text-neutral-950">
                  <time
                    dateTime={post.date.split("-")[0]}
                    className="font-semibold"
                  >
                    {formatDate(post.date, "PPP")}
                  </time>
                  <span className="text-neutral-300" aria-hidden="true">
                    /
                  </span>
                  <span>Insight</span>
                </p>
                <p className="mt-6 font-display text-2xl font-semibold text-primary">
                  {post.title}
                </p>
                <div
                  className="mt-4 line-clamp-4 text-sm leading-6 text-gray-600"
                  dangerouslySetInnerHTML={{ __html: post.excerpt }}
                />
              </article>
            </FadeIn>
          ))}
        </FadeInStagger>
      </Container>
    </>
  );
}

export function ErrorBoundary() {
  return <GeneralErrorBoundary />;
}
